import React from 'react';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

interface Props {
  children: React.ReactNode;
}

const useStyles = makeStyles<Theme>(({ zIndex }) => ({
  root: {
    position: 'sticky',
    top: 0,
    zIndex: zIndex.appBar,
  },
}));

export function PageHeader({ children }: Props): React.ReactElement {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
}
